import { IconVehicleMoto, IconVehicleCar, IconVehicleElectric } from '../assets/icons'

export const OPTIONS_VEHICLE_TYPE_INFO_VEHICLE = [
  { vehicleType: 30, label: 'Xe máy', value: 30, IconComponent: IconVehicleMoto },
  { vehicleType: 1, label: 'Ô tô', value: 1, IconComponent: IconVehicleCar },
  { vehicleType: 40, label: 'Xe máy điện', value: 40, IconComponent: IconVehicleElectric }
]
